
import './App.css';
import Landing from './Components/Landing';

function App() {
  return (
    <div >
      <Landing/>
    
    </div>
  );
}

export default App;
